<template>
  <v-expansion-panels focusable>
    <BonLivraisonExpansionPanel :accounts="accounts" :users="users" />
    <BonRetourExpansionPanel :accounts="accounts" :users="users" />
    <BonInstallationExpansionPanel :accounts="accounts" :users="users" />
    <FichePreparationExpansionPanel :accounts="accounts" :users="users" :products="products"/>
    <FicheSignalementExpansionPanel :accounts="accounts" :users="users" />
  </v-expansion-panels>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import BonLivraisonExpansionPanel from "@/components/BonLivraisonExpansionPanel.vue";
import BonRetourExpansionPanel from "@/components/BonRetourExpansionPanel.vue";
import BonInstallationExpansionPanel from "@/components/BonInstallationExpansionPanel.vue";
import FichePreparationExpansionPanel from "@/components/FichePreparationExpansionPanel.vue";
import FicheSignalementExpansionPanel from "@/components/FicheSignalementExpansionPanel.vue";
import { ReservationStatus, type Product, type User } from "@/types";
import type { Account } from "@/types";
import { getAllAccounts } from "@/utils/account-api";
import { getAllTechnicians } from "@/utils/user-api";
import { getFilteredProducts } from "@/utils/product-api";

const accounts = ref<Account[]>([]);
const users = ref<User[]>([]);
const products = ref<(Product | { type: 'subheader'; title: string })[]>([]);

onMounted(async () => {
  // Load accounts
  accounts.value = await getAllAccounts();

  const fetchedProducts = await getFilteredProducts([ReservationStatus.AVAILABLE]);

  const groupedProducts: (Product | { type: 'subheader'; title: string })[] = [];
  const grouped = new Map<string, Product[]>();
  for (const product of fetchedProducts) {
    const status = product.productStatus;
    if (!grouped.has(status)) grouped.set(status, []);
    grouped.get(status)!.push(product);
  }
  for (const [status, items] of grouped) {
    groupedProducts.push({ type: 'subheader', title: status });
    groupedProducts.push(...items);
  }
  products.value = groupedProducts as any;

  // Load users and add "Autre"
  const fetchedUsers = await getAllTechnicians();
  const autreUser: User = {
    lastname: "personne",
    name: "Autre",
    fullName: "Autre personne",
    technical: true,
  } as User;

  fetchedUsers.push(autreUser);

  users.value = fetchedUsers;
});
</script>
